import { r as l, a as c, h as o, H as h, o as d } from "./main-bb89b2f2.js";
import "vue";
const u = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.block{display:block}.ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}:host{display:block}.skeleton-containers{background-color:var(--color-neutral-steel-200);height:100%;width:100%}.animation{animation:skeleton-loading 1s ease-out infinite alternate;animation-delay:.1s}@keyframes skeleton-loading{0%{background-color:var(--color-neutral-steel-100)}to{background-color:var(--color-neutral-steel-300)}}.static{position:static}", p = u, s = {
  checkbox: {
    width: "24px",
    height: "24px",
    radius: "0px"
  },
  radiobutton: {
    width: "24px",
    height: "24px",
    radius: "100%"
  },
  avatar: {
    width: "48px",
    height: "48px",
    radius: "100%"
  },
  default: {
    width: "100%",
    height: "100%",
    radius: "0px"
  }
}, b = class {
  constructor(e) {
    l(this, e), this.height = "full", this.radius = void 0, this.start = !1, this.type = "default", this.width = "100%", this.screenSize = void 0;
  }
  connectedCallback() {
    const e = document.documentElement, r = "breakpoint", a = {
      attributes: !0
    }, t = (n) => {
      const i = d(r, n);
      i !== null && (this.screenSize = i);
    };
    this.observer = new MutationObserver(t), this.observer.observe(e, a);
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
  componentWillLoad() {
    this.screenSize = c();
  }
  render() {
    const e = this.type === "default" ? this.radius : s[this.type].radius, r = this.type === "default" ? this.width : s[this.type].width, a = this.type === "default" ? this.getHeightValue(this.height) : s[this.type].height, t = this.height === "full" ? s[this.type].height : this.getHeightValue(this.height), n = {
      borderRadius: e
    }, i = {
      width: this.type === "avatar" ? t : r,
      height: this.type === "avatar" ? t : a
    };
    return o(h, { key: "6c3bb1434b71ab2a55efcee4d4770ac28138841b", style: i }, o("div", { key: "70549df900ebf37136e00789467a88616e9f1265", class: {
      "skeleton-containers": !0,
      animation: this.start
    }, style: n }, o("slot", { key: "ccf45a446bbc9ed4e6b3ae726c216df48383a190" })));
  }
  // eslint-disable-next-line complexity
  getHeightValue(e) {
    switch (e) {
      case "full":
        return "100%";
      case "xs":
        return "16px";
      case "s":
        return "24px";
      case "m":
        return "32px";
      case "l":
        return "40px";
      case "xl":
        return "48px";
      case "xxl":
        return "56px";
      case "3xl":
        return "64px";
      case "4xl":
        return "72px";
      case "5xl":
        return "80px";
      case "6xl":
        return "96px";
      case "h1":
        return this.screenSize === "isDesktop" ? "36px" : this.screenSize === "isTablet" ? "28px" : "26px";
      case "h2":
        return this.screenSize === "isDesktop" ? "28px" : this.screenSize === "isTablet" ? "24px" : "22px";
      case "h3":
        return this.screenSize === "isDesktop" ? "24px" : (this.screenSize === "isTablet", "20px");
      case "h4":
        return this.screenSize === "isDesktop" ? "20px" : (this.screenSize === "isTablet", "18px");
      case "copyXS":
        return "12px";
      case "copyS":
        return "14px";
      case "copyM":
        return "16px";
      case "copyL":
        return "18px";
      case "button":
        return "48px";
      default:
        return e;
    }
  }
};
b.style = p;
export {
  b as patternlib_skeletonloader
};
